import { Buffer } from 'buffer';
import { ml_dsa87 } from '@noble/post-quantum/ml-dsa';
import { arrayBufferToBase64, ConstantsUtil } from '@utils';

var tokenCreationE2EE = function tokenCreationE2EE() {
  var currentDate = new Date();
  var id = sessionStorage.getItem('id');
  var cypherText = sessionStorage.getItem(ConstantsUtil.localStorage.mlCypherText);
  var secretKey = sessionStorage.getItem(ConstantsUtil.localStorage.mldsaSecret);
  var stringifyPayload = JSON.stringify({
    id: id,
    timestamp: currentDate.getTime(),
    ct: cypherText
  });
  var leftPart = btoa(stringifyPayload);
  var rightPart = ml_dsa87.sign(Buffer.from(secretKey || '', 'base64'), Buffer.from(leftPart, 'utf-8'));
  var token = leftPart + '.' + arrayBufferToBase64(rightPart);
  return token;
};

export { tokenCreationE2EE };